import request from '../request';

// 上传封面
export function uploadImage(params) {
    return request('/article/uploadImage', {
        method: 'post',
        params,
    });
}

// 获取经验分类
export function getArticleTypes() {
    return request('/articleFl/getArticleFls', {
        method: 'get'
    });
}

// 获取经验列表
export function getArticleList(params) {
    return request('/article/getArticleList', {
        method: 'GET',
        params
    });
}

// 获取经验详情
export function getArticleDetail(params) {
    return request('/article/getArticleById', {
        method: 'GET',
        params
    });
}

// 获取用户经验列表
export function getUserArticleList(params) {
    return request('/article/getUserArticleList', {
        method: 'GET',
        params
    });
}

// 获取用户经验收藏列表
export function getUserCollectArticleList(params) {
    return request('/article/getUserArticleCollection', {
        method: 'GET',
        params
    });
}

// 浏览经验
export function viewArticle(params) {
    return request('/article/viewArticle', {
        method: 'GET',
        params
    });
}

// 点赞
export function zanArticle(params) {
    return request('/article/zanArticle', {
        method: 'GET',
        params
    });
}

// 取消点赞
export function cancleZanArticle(params) {
    return request('/article/cancleZanArticle', {
        method: 'GET',
        params
    });
}

// 是否点赞
export function isZanArticle(params) {
    return request('/article/isZanArticle', {
        method: 'GET',
        params
    });
}

// 收藏
export function collectArticle(params) {
    return request('/article/collectArticle', {
        method: 'GET',
        params
    });
}

// 取消收藏
export function cancleCollectArticle(params) {
    return request('/article/cancleCollectArticle', {
        method: 'GET',
        params
    });
}

// 是否收藏
export function isCollectArticle(params) {
    return request('/article/isCollectArticle', {
        method: 'GET',
        params
    });
}

// 新增文章
export function addArticle(params) {
    return request('/article/publishArticle', {
        type: 'formData',
        method: 'POST',
        params
    });
}

// 编辑文章
export function editArticle(params) {
    return request('/article/modifyArticle', {
        type: 'formData',
        method: 'POST',
        params
    });
}

// 删除用户文章
export function deleteArticle(params) {
    return request('/article/userDeleteArticle', {
        method: 'GET',
        params
    });
}

// 获取用户文章详情
export function getUserArticleDetail(params) {
    return request('/article/getArticleByIdToModify', {
        method: 'GET',
        params
    });
}

// 导入文章
export function importArticle(params) {
    // return new Promise(resolve => {
    //     resolve({
    //         code: 0,
    //         data: {
    //             title: '111111111',
    //             content: '22222222222222'
    //         }
    //     })
    // })
    return request('/article/importArticle', {
        method: 'GET',
        params
    });
}

// 上传视频
export function uploadVideo(params) {
    return request('/file/uploadLocal?type=work', {
        method: 'POST',
        params
    });
}
